<template>
  <div class="simple-slider relative">
    <flickity ref="flickity" :options="options">
      <slot></slot>
    </flickity>

    <div class="absolute left-0 bottom-40pc w-100 grid cf"
         v-if="showButtons">
      <div class="ph3 ph0-l col-l col-10-l push-1-l">
        <div class="flex justify-between">
          <button
            type="button"
            @click="previous"
            class="simple-slider__btn">
            <svg class="rotate-180" height="12" viewBox="0 0 7 12" width="7" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink">
              <g fill="none" fill-rule="evenodd" transform="translate(-13 -10)">
                <path fill="currentColor"
                      d="m13.2191312 20.375305 1.5617376 1.24939 4.499756-5.624695-4.499756-5.624695-1.5617376 1.24939 3.500244 4.375305z"/>
              </g>
            </svg>
          </button>

          <button
            type="button"
            @click="next"
            class="simple-slider__btn">
            <svg height="12" viewBox="0 0 7 12" width="7" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink">
              <g fill="none" fill-rule="evenodd" transform="translate(-13 -10)">
                <path fill="currentColor"
                      d="m13.2191312 20.375305 1.5617376 1.24939 4.499756-5.624695-4.499756-5.624695-1.5617376 1.24939 3.500244 4.375305z"/>
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Flickity from 'vue-flickity'

export default {
  name: 'SimpleSlider',

  components: {
    Flickity
  },

  props: {
    options: {
      type: Object,
      default () {
        return {
          wrapAround: true,
          pageDots: false,
          prevNextButtons: false
        }
      }
    }
  },

  data () {
    return {
      showButtons: false
    }
  },

  mounted: function () {
    const multipleImages = this.$refs.flickity.cells().length > 1
    if (multipleImages) {
      this.showButtons = true
    }
  },

  methods: {
    next () {
      this.$refs.flickity.next()
    },

    previous () {
      this.$refs.flickity.previous()
    }
  }
}
</script>
